(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["finalize-order-form"] && !Shopify.designMode) return;
  try {
    class FinalizeOrderForm extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.placeShopifyForm();
      this.addEventListener('change', (event) => {
        if (!event.target.matches('input[name="finalize_order_reason"]')) return;

        const update = () => this.updatePanels();

        if (document.startViewTransition) {
          document.startViewTransition(update);
        } else {
          update();
        }

        if (event.target.value === 'shipping') {
          this.scheduleRedirect();
        } else {
          window.clearTimeout(this.redirectTimeout);
        }
      });
      this.updatePanels();
    }

    placeShopifyForm() {
      const formSlot = this.querySelector('[data-shopify-forms-slot]');
      const sectionContent = this.closest('.finalize-order-page');
      const appBlock = sectionContent?.querySelector(':scope > .shopify-app-block');

      if (formSlot && appBlock) {
        formSlot.append(appBlock);
      }
    }

    updatePanels() {
      const selectedChoice = this.querySelector('input[name="finalize_order_reason"]:checked');

      this.querySelectorAll('[data-finalize-order-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.finalizeOrderPanel !== selectedChoice?.value;
      });
    }

    scheduleRedirect() {
      window.clearTimeout(this.redirectTimeout);
      this.redirectTimeout = window.setTimeout(() => {
        window.location.assign(this.dataset.discountUrl);
      }, 1200);
    }
  }

  if (!customElements.get('finalize-order-form')) {
    customElements.define('finalize-order-form', FinalizeOrderForm);
  }
  } catch(e) { console.error(e); }
})();

})();
